import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const pageTitles = {
  "/panel/billing/user-settings": "User Billing Settings",
  "/panel/billing/daily-fee-summary": "Daily Fee Summary",
  "/panel/billing/credit-ledger": "Credit Ledger",
  "/panel/billing/credit-balance": "Credit Balance",
};

const BillingPage = (props) => {
  const title = pageTitles[props.location.pathname] || "Billing";

  return (
    <Box sx={{ p: 2 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          This billing module page is ready for implementation.
        </Typography>
      </Paper>
    </Box>
  );
};

export default BillingPage;
